// eslint-disable-next-line import/no-cycle
import { EArchivedListActionTypes, IArchivedListRequest } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TChatListSetSucceedPayload } from '../chatList';

/**
 * Запрос за списком архивных чатов
 */
export const setArchivedListPending = actionGenerator<EArchivedListActionTypes.SetPending, IArchivedListRequest>(
  EArchivedListActionTypes.SetPending,
);

/**
 * Установить список архивных чатов
 */
export const setArchivedListSucceed = actionGenerator<EArchivedListActionTypes.SetSucceed, TChatListSetSucceedPayload>(
  EArchivedListActionTypes.SetSucceed,
);

/**
 * Установить ошибку запроса списка архивных чатов
 */
export const setArchivedListFailed = actionGenerator<EArchivedListActionTypes.SetFailed, void>(
  EArchivedListActionTypes.SetFailed,
);
